"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _axios = _interopRequireDefault(require("axios"));
var _intlDesignUi = require("@tencent/intl-design-ui");
require("../../common/style.scss");
var _formatVodData2 = require("../../utils/formatVodData");
var _formatCommodityData = require("../../utils/formatCommodityData");
var _reportUtil = require("../../utils/reportUtil");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  BuyProduct1 = _require.BuyProduct1;
const formatBuyProduct = (properties, options = {}) => {
  const _properties$desc = properties.desc,
    desc = _properties$desc === void 0 ? '' : _properties$desc,
    _properties$buyProduc = properties.buyProductList,
    buyProductList = _properties$buyProduc === void 0 ? [] : _properties$buyProduc; // 第一条数据是模块名称
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const configuration = buyProductList.length > 0 ? buyProductList.map((productItem, index) => {
    const _productItem$product = productItem.product1Title,
      product1Title = _productItem$product === void 0 ? '' : _productItem$product,
      _productItem$product2 = productItem.product1Duration,
      product1Duration = _productItem$product2 === void 0 ? '' : _productItem$product2,
      _productItem$product3 = productItem.product1Content,
      product1Content = _productItem$product3 === void 0 ? '' : _productItem$product3,
      _productItem$product4 = productItem.product1BtnTxt,
      product1BtnTxt = _productItem$product4 === void 0 ? '' : _productItem$product4,
      _productItem$product5 = productItem.product1BtnHref,
      product1BtnHrefBase = _productItem$product5 === void 0 ? '' : _productItem$product5,
      _productItem$productL = productItem.productList,
      productList = _productItem$productL === void 0 ? [] : _productItem$productL,
      _productItem$product6 = productItem.product1BgType,
      product1BgType = _productItem$product6 === void 0 ? 'https://staticintl.cloudcachetci.com/cms/backend-cms/VeCP394_essential.png' : _productItem$product6,
      _productItem$commodit = productItem.commodityObject,
      commodityObject = _productItem$commodit === void 0 ? '{}' : _productItem$commodit,
      _productItem$tagTxt = productItem.tagTxt,
      tagTxt = _productItem$tagTxt === void 0 ? '' : _productItem$tagTxt;
    const product1BtnHref = formatUrlString(product1BtnHrefBase);
    const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
    const resultList = productList.map(productItem => {
      const _productItem$sonTitle = productItem.sonTitle,
        sonTitle = _productItem$sonTitle === void 0 ? '' : _productItem$sonTitle,
        _productItem$sonText = productItem.sonText,
        sonText = _productItem$sonText === void 0 ? '' : _productItem$sonText;
      return {
        title: sonTitle,
        text: sonText
      };
    });
    return _objectSpread(_objectSpread({
      title: product1Title,
      duration: product1Duration,
      content: formatUrlInText(product1Content),
      but_txt: product1BtnTxt,
      but_href: product1BtnHref,
      text_list: resultList,
      backgroundUrl: product1BgType
    }, resultCommodityObject), {}, {
      tagTxt,
      extendProps: {
        'report-event-goal': 'click_buy_product_4',
        'report-event': 'click_buy_product_4_button',
        'report-ext1': index,
        'report-ext2': product1BtnTxt,
        'report-ext3': product1BtnHref
      }
    });
  }) : [];
  return {
    desc: formatUrlInText(desc),
    configuration
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos,
  lang
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (data) {
    const _ref = data,
      modTitle = _ref.modTitle,
      color = _ref.color,
      backgroundImage = _ref.backgroundImage,
      porintId = _ref.porintId,
      colorTheme = _ref.colorTheme,
      originDesc = _ref.desc,
      _ref$cardList = _ref.cardList,
      cardList = _ref$cardList === void 0 ? [] : _ref$cardList;
    const _React$useState = React.useState(cardList),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      ftList = _React$useState2[0],
      setFtList = _React$useState2[1];
    const _React$useState3 = React.useState(''),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      forDesc = _React$useState4[0],
      setForDesc = _React$useState4[1];
    if (!cardList.length) {
      React.useEffect(() => {
        (0, _axios.default)({
          method: 'post',
          url: `/render/api/configsolution/getPageDetail`,
          data: {
            eid: 'freetier'
          }
        }).then(({
          data
        }) => {
          // 找出当前组件对应的数据列表
          if (data) {
            let buyProduct1CompData = data[lang].components.filter(o => o.name === 'BuyProduct1');
            // 如果当前语言下没有配置对应的免费数据专区列表，默认取英文
            if (!buyProduct1CompData.length) {
              buyProduct1CompData = data['en'].components.filter(o => o.name === 'BuyProduct1');
            }
            const buyProductList = buyProduct1CompData[0].data.buyProductList;
            const _formatBuyProduct = formatBuyProduct({
                desc: originDesc,
                buyProductList
              }, {
                domains
              }),
              desc = _formatBuyProduct.desc,
              configuration = _formatBuyProduct.configuration;
            setForDesc(desc);
            setFtList(configuration);
          } else {
            console.log('gems端请求跨域~ 不给看数据');
          }
        }).catch(e => console.log(e, 'error::'));
      }, []);
    }

    // 处理组件背景色
    const bgStyle = color ? (0, _componentUtils.doComponentsBgColorEvent)(color) : {};
    const _formatVodData = (0, _formatVodData2.formatVodData)(backgroundImage),
      url = _formatVodData.url;
    if (url) {
      bgStyle['backgroundImage'] = `url(${url})`;
      bgStyle['backgroundSize'] = 'cover';
    }
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: porintId || modTitle
    }, (0, _reportUtil.reportShow)(['show_buyProduct1', componentKey, modTitle])), ftList.length > 0 ? /*#__PURE__*/React.createElement(BuyProduct1, {
      flexTitle: modTitle,
      desc: forDesc,
      configuration: ftList,
      style: bgStyle,
      colorTheme: colorTheme,
      onCallback: item => {
        window.asyncReceiveCommodity(item);
      }
    }) : /*#__PURE__*/React.createElement(_intlDesignUi.FlexTitle, {
      flexTitle: modTitle,
      desc: originDesc,
      style: bgStyle
    }));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
}